export const COUNTRY_SELECTOR_DEFAULT = 'All countries'